import { motion } from 'framer-motion';
import { Code, Palette, BrainCircuit, MessageSquare } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const AIToolsNavigation = () => {
  const { t } = useLanguage();

  const toolCategories = [
    {
      key: 'creative',
      icon: Palette,
      tools: [
        { name: 'ChatGPT', url: 'https://chat.openai.com' },
        { name: 'Midjourney', url: 'https://midjourney.com' },
        { name: 'Claude', url: 'https://claude.ai' },
        { name: 'Stable Diffusion', url: 'https://stability.ai' }
      ]
    },
    {
      key: 'business',
      icon: BrainCircuit,
      tools: [
        { name: 'Notion AI', url: 'https://notion.so' },
        { name: 'Copy.ai', url: 'https://copy.ai' },
        { name: 'Jasper', url: 'https://jasper.ai' },
        { name: 'Grammarly', url: 'https://grammarly.com' }
      ]
    },
    {
      key: 'developer',
      icon: Code,
      tools: [
        { name: 'GitHub Copilot', url: 'https://github.com/features/copilot' },
        { name: 'Cursor', url: 'https://cursor.sh' },
        { name: 'Replit Ghostwriter', url: 'https://replit.com/ghostwriter' },
        { name: 'CodeWhisperer', url: 'https://aws.amazon.com/codewhisperer' }
      ]
    },
    {
      key: 'learning',
      icon: MessageSquare,
      tools: [
        { name: 'Khan Academy', url: 'https://khanacademy.org' },
        { name: 'Coursera AI', url: 'https://coursera.org' },
        { name: 'Perplexity', url: 'https://perplexity.ai' },
        { name: 'Hugging Face', url: 'https://huggingface.co' }
      ]
    }
  ];

  return (
    <div>
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('tools.title')}</h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          {t('tools.subtitle')}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {toolCategories.map((category) => (
          <motion.div
            key={category.key}
            className="bg-white bg-opacity-50 backdrop-blur-sm rounded-sm border border-vintage-muted p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
            whileHover={{ y: -5 }}
          >
            <div className="flex items-center mb-4">
              <category.icon className="w-6 h-6 mr-3 text-vintage-accent" />
              <h3 className="font-display text-lg font-semibold">{t(`tools.category.${category.key}`)}</h3>
            </div>
            <ul className="space-y-3 font-serif">
              {category.tools.map((tool) => (
                <li key={tool.name}>
                  <a
                    href={tool.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-vintage-ink hover:text-vintage-accent transition-colors"
                  >
                    {tool.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AIToolsNavigation; 